





















































































































































/* tslint:disable:forin */
import { ChoiceOption, ChoiceOptionList, OrderRec } from '@/interfaces';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import GroupDetail from '@/components/orderdocs/GroupDetail.vue';
import LineDetail from '@/components/orderdocs/LineDetail.vue';
import DraggableTreeview from '@/components/orderdocs/DraggableTreeview.vue';
import LinesTable from '@/components/orderdocs/LinesTable.vue';
import DocumentMixin from '@/mixins/DocumentMixin';

@Component({
  components: {
    GroupDetail,
    LineDetail,
    LinesTable,
    DraggableTreeview
  }
})
export default class DocumentTree extends Mixins(DocumentMixin) {
  @Prop() public readonly rec!: OrderRec;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

  public version = 0;
  public active = [];
  public open = [];
  public items: any[] = [];
  public localLineId = 0;
  public deleteDialogValue = false;
  public totalAmountExclusive = 0;
  public totalAmountInclusive = 0;

  public get rootSelected() {
    return this.getSelectedItem === 'g0';
  }

  public get groupSelected() {
    return this.isGroup(this.getSelectedItem);
  }

  public get lineSelected() {
    return this.isLine(this.getSelectedItem);
  }

  public get selected() {
    const id = this.getSelectedItem;

    if (id) {
      if (id === 'g0') {
        return { group_id: 0 };
      } else {
        return this.getItem(id, this.rec);
      }
    } else {
      return undefined;
    }
  }

  public get selectedLines() {
    if (this.rec.lines) {
      return this.rec.lines.filter(
        l => l.parent_group_id === this.parseId(this.getSelectedItem)
      );
    } else {
      return [];
    }
  }

  public getNextGroupId() {
    let maxId = 0;
    this.rec.groups.forEach(
      g => (maxId = g.group_id > maxId ? g.group_id : maxId)
    );
    return maxId + 1;
  }

  public addGroup() {
    const groupId = this.getNextGroupId();
    const group = {
      id: 0,
      group_id: groupId,
      orderdoc_id: this.rec.id,
      parent_group_id: 0,
      index: this.items.length,
      description: 'Nieuwe groep',
      comments: '',
      is_option: false
    };
    this.rec.groups.push(group);
    this.renderItems();
    this.setSelectedItem('g' + groupId);
  }

  public deleteGroup(id) {
    const groupId = this.parseId(id);
    this.rec.groups = this.rec.groups.filter(
      g => g.parent_group_id !== groupId && g.group_id !== groupId
    );
    this.rec.lines = this.rec.lines.filter(l => l.parent_group_id !== groupId);
    this.setSelectedItem('');
    this.renderItems();
  }

  public addItem(parentGroupId, index, select = true) {
    this.localLineId -= 1;
    const line = this.newLine(this.localLineId, parentGroupId, index, this.rec);
    if (this.rec.global_vatrate_id) {
      line.vatrate_id = this.rec.global_vatrate_id;
    }
    this.rec.lines.push(line as any);
    this.renderItems();
    if (select) {
      this.setSelectedItem('l' + this.localLineId);
    }
  }

  public addItemToSelected() {
    const groupId = this.selected.group_id;
    let index = 0;
    this.rec.groups.forEach(
      g => (index = g.parent_group_id === groupId ? index + 1 : index)
    );
    this.rec.lines.forEach(
      l => (index = l.parent_group_id === groupId ? index + 1 : index)
    );
    this.addItem(groupId, index, false);
  }

  public deleteItem(id) {
    this.rec.lines.splice(
      this.rec.lines.findIndex(l => l.id === this.parseId(id)),
      1
    );
    this.renderItems();
  }

  public itemsChanged() {
    this.items.forEach((item, index) => this.updateItem(item, index, 0));
    this.calculateTotalAmounts();
  }

  public updateItem(item, index, parentId) {
    const recItem = this.getItem(item.id, this.rec);
    if (recItem) {
      recItem.index = index;
      recItem.parent_group_id = parentId;
    }

    if (item && item.children) {
      item.children.forEach((child, childIndex) =>
        this.updateItem(child, childIndex, this.parseId(item.id))
      );
    }
  }

  public renderItems() {
    const rec = this.rec;
    if ('groups' in rec && 'lines' in rec) {
      const map = {};
      const items: object[] = [];
      const groups: any[] = [];
      for (const i in rec.groups) {
        groups[i] = {
          id: 'g' + rec.groups[i].group_id,
          name: rec.groups[i].description,
          parent_group_id: 'g' + rec.groups[i].parent_group_id,
          index: rec.groups[i].index
        };
        map[groups[i].id] = i;
        groups[i].children = [];
      }

      for (const i in groups) {
        const node = groups[i];
        if (node.parent_group_id !== 'g0') {
          groups[map[node.parent_group_id]].children.push(node);
        } else {
          items.push(node);
        }
      }

      for (const i in rec.lines) {
        const node = {
          id: 'l' + rec.lines[i].id,
          name: rec.lines[i].description,
          parent_group_id: 'g' + rec.lines[i].parent_group_id,
          index: rec.lines[i].index
        };
        if (node.parent_group_id !== 'g0') {
          groups[map[node.parent_group_id]].children.push(node);
        } else {
          items.push(node);
        }
      }

      this.sortItems(items);

      this.items = items;
    }
    this.calculateTotalAmounts();
  }

  public calculateTotalAmounts() {
    let totalExcl = 0;
    let totalIncl = 0;
    for (const i of this.items) {
      this.calculateAmounts(i);
      const item = this.getItem(i.id, this.rec);
      if (!item.is_option) {
        totalExcl += item.amount_exclusive;
        totalIncl += item.amount_inclusive;
      }
    }
    this.totalAmountExclusive = totalExcl;
    this.totalAmountInclusive = Math.round(totalIncl * 100) / 100;
    this.version += 1;
  }

  public calculateAmounts(i) {
    if (this.isLine(i.id)) {
      // LINE OBJECT
      const l: any = this.getItem(i.id, this.rec);
      l.amount_exclusive = 0;
      l.amount_inclusive = 0;
      if (l.quantity && l.unit_price) {
        l.amount_exclusive = Math.round(l.quantity * l.unit_price * 100) / 100;
        let vatrates: ChoiceOption[] = this.vatrates;
        if (!vatrates) {
          vatrates = this.getCachedChoice('vatrates-choice').records;
        }
        if (l.vatrate_id && vatrates) {
          const vatrate: any = vatrates.find(v => v.value === l.vatrate_id);
          l.amount_inclusive = l.amount_exclusive * (1 + vatrate.text / 100);
        }
      }
    } else {
      // GROUP OBJECT
      const g: any = this.getItem(i.id, this.rec);
      g.amount_exclusive = 0;
      g.amount_inclusive = 0;
      for (const c of i.children) {
        this.calculateAmounts(c);
        const child = this.getItem(c.id, this.rec);
        if (!child.is_option) {
          g.amount_exclusive += child.amount_exclusive;
          g.amount_inclusive += child.amount_inclusive;
        }
      }
    }
  }

  public initialize() {
    this.renderItems();
    // Select first item
    if (this.items && this.items.length > 0) {
      // Show root
      this.setSelectedItem('g0');
    }
  }

  @Watch('rec') public recChanged(value: any, oldValue: any) {
    if (value && value.id !== 0) {
      this.initialize();
    }
  }
}
